export const getPartnerSdk = () => window.PartnerExpressFactory;
